import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faGraduationCap, faHospital, faUserNurse, faGlobe } from '@fortawesome/free-solid-svg-icons';
import programStudi from '../data/programStudi';
import '../styles/ProgramStudi.css';

// Map icon type to FontAwesome icon
const iconMap = {
  hospital: faHospital,
  userNurse: faUserNurse,
  globe: faGlobe
};

const ProgramStudiSection = () => {
  return (
    <section className="section program-studi">
      <div className="container">
        <div className="section-title">
          <h2>Program Studi</h2>
          <p>
            Pilih program studi yang sesuai dengan minat dan bakat Anda untuk 
            membangun karir profesional di bidang kesehatan
          </p>
        </div>

        <div className="prodi-grid">
          {programStudi.map((prodi) => (
            <div key={prodi.id} className="prodi-card">
              <div className="prodi-icon">
                <FontAwesomeIcon icon={iconMap[prodi.iconType]} />
              </div>
              <div className="prodi-header">
                <div>
                  <h3>{prodi.nama}</h3>
                  <span className="prodi-jenjang">{prodi.jenjang}</span>
                </div>
              </div>
              <p className="prodi-desc">{prodi.deskripsi}</p>
              <div className="prodi-info">
                <div className="prodi-info-item">
                  <FontAwesomeIcon icon={faClock} />
                  <span>{prodi.durasi}</span>
                </div>
                <div className="prodi-info-item">
                  <FontAwesomeIcon icon={faGraduationCap} />
                  <span>{prodi.gelar}</span>
                </div>
              </div>
              <div className="prodi-card-footer">
                <Link to="/program-studi" className="btn btn-secondary">
                  Lihat Detail
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramStudiSection;
